import { useTranslation } from "react-i18next";
import StockHistory from "../../../components/Custom/StockControl/Stock/StockHistory";
import PageTitle from "../../../layouts/PageTitle";
import { Col, Row } from "react-bootstrap";

const StockList = () => {

    const { t } = useTranslation();

    return (
        <>
            <PageTitle activeMenu={t('check_stock')} motherMenu={t('stock_control')} />
            <Row>
                <Col className="col-md-12">
                    <StockHistory/>
                </Col>
            </Row>
        </>
    );
}

export default StockList;